import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import {
  AutoMatchResult, ImportReport, OurDocType, StatementImportParams, StatementReport, StatementStatus, StatementSummary,
} from '../interfaces/procurement/supplierStatement.interface';

const E = ENDPOINTS.SUPPLIER_STATEMENT;

const importForm = (file: File, p: StatementImportParams) => {
  const form = new FormData();
  form.append('file', file);
  form.append('supplierId', p.supplierId);
  form.append('periodFrom', p.periodFrom);
  form.append('periodTo', p.periodTo);
  if (p.openingBalance != null) form.append('openingBalance', String(p.openingBalance));
  if (p.closingBalance != null) form.append('closingBalance', String(p.closingBalance));
  if (p.notes) form.append('notes', p.notes);
  return form;
};

/** B4-G: supplier statement import, matching, report, sign-off. */
export const SupplierStatementService = {
  list: async (institutionId: string, supplierId?: string, status?: StatementStatus): Promise<StatementSummary[]> =>
    (await axios.get(E.LIST(institutionId), { params: { supplierId: supplierId || undefined, status: status || undefined } })).data,
  report: async (institutionId: string, id: string): Promise<StatementReport> =>
    (await axios.get(E.REPORT(id, institutionId))).data,
  dryRun: async (institutionId: string, file: File, p: StatementImportParams): Promise<ImportReport> =>
    (await axios.post(E.DRY_RUN(institutionId), importForm(file, p), { headers: { 'Content-Type': 'multipart/form-data' } })).data,
  import: async (institutionId: string, file: File, p: StatementImportParams): Promise<StatementSummary> =>
    (await axios.post(E.IMPORT(institutionId), importForm(file, p), { headers: { 'Content-Type': 'multipart/form-data' } })).data,
  autoMatch: async (institutionId: string, id: string): Promise<AutoMatchResult> =>
    (await axios.post(E.ACTION(id, 'auto-match', institutionId))).data,
  match: async (institutionId: string, id: string, lineId: string, docType: OurDocType, docId: string): Promise<StatementReport> =>
    (await axios.post(E.ACTION(id, 'match', institutionId), { lineId, docType, docId })).data,
  unmatch: async (institutionId: string, id: string, lineId: string): Promise<StatementReport> =>
    (await axios.post(E.UNMATCH(id, lineId, institutionId))).data,
  signOff: async (institutionId: string, id: string, note?: string): Promise<StatementReport> =>
    (await axios.post(E.ACTION(id, 'sign-off', institutionId), { note: note || null })).data,
  remove: async (institutionId: string, id: string): Promise<void> => {
    await axios.delete(E.ONE(id, institutionId));
  },
  downloadXlsx: async (institutionId: string, id: string): Promise<Blob> =>
    (await axios.get(E.REPORT_XLSX(id, institutionId), { responseType: 'blob' })).data,
  downloadLetter: async (institutionId: string, id: string): Promise<Blob> =>
    (await axios.get(E.LETTER(id, institutionId), { responseType: 'blob' })).data,
};
